var RouterAction;
((RouterAction2) => {
  RouterAction2.isCanActivate = (obj) => {
    return typeof obj?.canActivate === "function";
  };
  RouterAction2.isOnRouting = (obj) => {
    return typeof obj?.onRouting === "function";
  };
  RouterAction2.isHasActivate = (obj) => {
    return typeof obj?.hasActivate === "function";
  };
})(RouterAction || (RouterAction = {}));
export {
  RouterAction
};
//# sourceMappingURL=RouterAction.js.map
